var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 25C36.8334 25 38.3334 23.5 38.3334 21.6667L38.3167 21.5333L38.3334 21.5167V18.3333C38.3334 17.9 38.25 17.5 38.1 17.1167L33.0667 5.36665C32.5667 4.16665 31.3834 3.33332 30 3.33332H15C13.1667 3.33332 11.6667 4.83332 11.6667 6.66665V23.3333C11.6667 24.25 12.0334 25.0833 12.65 25.6833L23.6167 36.6667L25.3834 34.9167C25.8334 34.4667 26.1167 33.8333 26.1167 33.15L26.0667 32.6167L24.4834 25H35ZM8.33335 3.33332H1.66669V23.3333H8.33335V3.33332Z",
    fill: "#FF0C3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/ThumbsDown.280c0fbb474391b1981071dce809818f.svg";
export { ForwardRef as ReactComponent };